const EEG_ANNOTATION_CHANNEL_KEYS = new Set([
  "annotation",
  "annotations",
  "edfannotation",
  "edfannotations",
]);

function stripEegChannelPrefix(value: string): string {
  return value.replace(/^EEG\s+/i, "");
}

export function formatEegChannelLabel(
  channelLabel: string | null | undefined,
): string {
  const raw = stripEegChannelPrefix(String(channelLabel || "").trim());
  if (!raw) {
    return "";
  }

  return raw
    .replace(/\s*([/-])\s*/g, "$1")
    .replace(/[^A-Za-z0-9/ -]+/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/-+$/, "");
}

export function normalizeEegChannelKey(
  channelLabel: string | null | undefined,
): string {
  return formatEegChannelLabel(channelLabel)
    .replace(/\s+/g, "")
    .replace(/-+$/, "")
    .toLowerCase();
}

export function eegChannelLabelsMatch(
  left: string | null | undefined,
  right: string | null | undefined,
): boolean {
  const leftKey = normalizeEegChannelKey(left);
  const rightKey = normalizeEegChannelKey(right);
  return leftKey.length > 0 && leftKey === rightKey;
}

export function isEegAnnotationPseudoChannel(
  channelLabel: string | null | undefined,
): boolean {
  const channelKey = normalizeEegChannelKey(channelLabel);
  return channelKey.length > 0 && EEG_ANNOTATION_CHANNEL_KEYS.has(channelKey);
}

export function isRenderableEegSignalChannel(
  channelLabel: string | null | undefined,
): boolean {
  return (
    normalizeEegChannelKey(channelLabel).length > 0 &&
    !isEegAnnotationPseudoChannel(channelLabel)
  );
}

export function eegChannelLabelContainsContact(
  channelLabel: string | null | undefined,
  contactLabel: string | null | undefined,
): boolean {
  const channelKey = normalizeEegChannelKey(channelLabel);
  const contactKey = normalizeEegChannelKey(contactLabel);

  if (!channelKey || !contactKey) {
    return false;
  }

  if (channelKey === contactKey) {
    return true;
  }

  return channelKey
    .split(/[-/]/)
    .map((token) => token.trim())
    .filter(Boolean)
    .includes(contactKey);
}
